module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-link/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = ./node_modules/gatsby-link/node_modules/babel-runtime/core-js/object/set-prototype-of.js
// module chunks = 168707334958949